export const MigustoTheme = {
  name: 'Migusto Theme',
  themeId: 'migusto',
  colors: {
    brand: {
      primary: {
        100: '#A9003D'
      },
      secondary: {
        100: '#BE406D'
      },
      accent: {
        100: '#D4809E'
      },
      text: {
        100: '#333333'
      },
      textInverted: {
        100: '#FFFFFF'
      },
      highlight: {
        100: '#D4809E'
      },
      altHighlight: {
        100: '#FF6600'
      },
      background: {
        100: '#F8F6ED'
      },
      alternative: {
        100: '#BBDEC2'
      }
    },
    tints: {
      gray: {
        10: '#f5f5f5',
        25: '#e8e8e8',
        40: '#d1d1d1',
        45: '#EDEDED',
        50: '#999999',
        60: '#76757F',
        75: '#585858',
        90: '#333333'
      },
      white: {
        100: '#FFFFFF'
      },
      black: {
        90: '#333333'
      }
    }
  },
  backgrounds: {
    tile: '#F8F5F2'
  },
  fonts: {
    families: {
      text: '"MarrSansRegular", sans-serif',
      notes: '"MarrSansRegular", sans-serif',
      heading: '"MarrSansSemibold", sans-serif',
      condensed: '"MarrSansSemibold", sans-serif',
      subHeading: '"MarrSansSemibold", sans-serif'
    }
  }
};